import { AlertTriangle } from '@untitled-ui/icons-react';
import type { TFunctionNonStrict } from 'i18next';
import { Trans } from 'react-i18next';

import { Button } from '../../../../../../components/buttons/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogTitle,
} from '../../../../../../components/dialog';
import { FeaturedIcon } from '../../../../../../components/featured-icon';
import { tGlobal, tNamespace } from '../../../../../../services/translation';

const t = tNamespace('app.integrations');

export type DeleteIntegrationDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onDelete: (integrationId: string) => void;
  integrationUrl: string;
  integrationId: string;
  isLoading?: boolean;
};

export function DeleteIntegrationDialog(props: DeleteIntegrationDialogProps) {
  const { open, onOpenChange, onDelete, integrationUrl, integrationId, isLoading } = props;

  return (
    <Dialog open={open} onOpenChange={isLoading ? undefined : onOpenChange}>
      <DialogContent hasCloseButton={!isLoading}>
        <div className="mb-6 flex items-center justify-center">
          <FeaturedIcon icon={<AlertTriangle />} color="yellow" />
        </div>
        <DialogTitle align="center">{t('deleteIntegration')}</DialogTitle>
        <DialogDescription align="center" className="text-dark-gray">
          <Trans
            i18nKey="deleteIntegrationDescription"
            t={t as unknown as TFunctionNonStrict}
            values={{ integrationUrl }}
            components={{
              span: <span className="font-body-2-sb text-dark-gray" />,
            }}
            className="text-branding-accent"
          />
        </DialogDescription>
        <DialogFooter>
          <Button
            size="xl"
            variant="outline"
            className="w-full"
            disabled={isLoading}
            onClick={function () {
              onOpenChange(false);
            }}
          >
            {tGlobal('cancel')}
          </Button>
          <Button
            size="xl"
            variant="destructive"
            className="w-full"
            loading={isLoading}
            onClick={function () {
              onDelete(integrationId);
            }}
          >
            <p className="whitespace-nowrap">{t('disconnect')}</p>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
